export { newsletterManifest } from "./newsletter-manifest";
